<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <ModuleShell :title="t('views.home.quickActions')" :icon="Zap" hide-action>
    <div class="grid grid-cols-3 gap-3" v-if="visibleActions.length > 0">
      <button
        v-for="action in visibleActions"
        :key="action.id"
        @click="router.push(action.route)"
        class="flex flex-col items-center justify-center gap-2 rounded-xl bg-[var(--color-primary-100)] p-3 text-center transition-colors hover:bg-[var(--color-primary-200)]"
      >
        <div class="rounded-full bg-[var(--color-primary-200)] p-2 text-[var(--color-primary-700)]">
          <component :is="action.icon" class="h-6 w-6" />
        </div>
        <span class="text-xs font-medium">{{ t(action.labelKey) }}</span>
      </button>
    </div>
    <div v-else class="text-center text-sm opacity-50 py-2">
      {{ t('views.more.quickLinks.description') }}
    </div>
  </ModuleShell>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { Zap } from 'lucide-vue-next'
import ModuleShell from '@/components/ui/layout/ModuleShell.vue'
import { useQuickActions } from '@/utils/useQuickActions.js'

const { t } = useI18n()
const router = useRouter()
const { AVAILABLE_ACTIONS, selectedActionIds } = useQuickActions()

const visibleActions = computed(() => {
  return selectedActionIds.value
    .map(id => AVAILABLE_ACTIONS.find(a => a.id === id))
    .filter(Boolean)
})
</script>